<template>
    <div>
        <div class="el-form-item__description is-bottom">
            营销词请勿填写【】，系统会自动拼接，营销词总字符长度不可超过{{ MarketWordMaxLength }}，和商品名称总字符长度不可超过{{ SKUNameMaxLength }}。
        </div>
        <div class="el-form-item__description is-bottom">
            营销词系统拼接示例:【火锅季】。
        </div>
        <div
            v-if="similarNamesWithMarketingWord.length"
            class="el-form-item__description is-bottom dark"
        >
            竞对相似品标题示例:
        </div>
        <div
            v-for="name in similarNamesWithMarketingWord"
            :key="`similar-${name}`"
            class="el-form-item__description is-bottom dark"
        >
            {{ name }}
        </div>
    </div>
</template>

<script>
import { MarketWordMaxLength, SKUNameMaxLength } from '../../../../services/editSkuName/validators';

export default {
    name: 'SKUName',
    props: {
        similarNamesWithMarketingWord: {
            type: Array,
            default: () => ([]),
        },
    },
    data() {
        return {
            MarketWordMaxLength,
            SKUNameMaxLength,
        };
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
.dark {
    color: #121924;
}
</style>
